import PrestationView from "@features/achats/components/prestations/PrestationView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ConciergeBell } from "lucide-react";

export const Route = createFileRoute("/_app/achats/prestations/$id/view")({
  staticData: {
    title: "Détails Prestation",
    icon: ConciergeBell,
    permission: PERMISSIONS.ACHATS.PRESTATIONS.VIEW,
    module: "achats",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: PrestationView,
});
